import { AlbumSaveData } from '../types/AlbumSaveData';

export async function saveAlbumToServer(
    albumSaveData: AlbumSaveData,
    setAlbumData: React.Dispatch<React.SetStateAction<AlbumSaveData>>,
    token: string | null,
    lastSavedDataRef?: React.MutableRefObject<AlbumSaveData | null>   // <-- optional param
): Promise<boolean> {
    try {
        // Prepare payload as server expects
        const payload = {
            albumName: albumSaveData.albumName,
            albumType: albumSaveData.albumType,
            albumSize: albumSaveData.size,
            layoutSize: albumSaveData.layoutSize,   // <-- add this
            pageCount: albumSaveData.pageCount,
            backgroundColor: albumSaveData.backgroundColor,
            cutArea: albumSaveData.cutArea,
            spineWidth: albumSaveData.spineWidth ?? 0,
            projectId: albumSaveData.projectId,

            //  ADD THESE
            opening:
                albumSaveData.albumType === "ARCH" ||
                    albumSaveData.albumType === "FMOUNTS" ||
                    albumSaveData.albumType === "FPRINTS" ||
                    albumSaveData.albumType === "HANDTORN"
                    ? albumSaveData.opening ?? null
                    : null,

            handtornMode:
                albumSaveData.albumType === "HANDTORN"
                    ? albumSaveData.handtornMode ?? "square"
                    : null,
            data: {
                pages: albumSaveData.pages,
                editorSettings: albumSaveData.editorSettings,
            }
        };
        const API_URL = process.env.REACT_APP_API_URL;
        const isNewAlbum = !albumSaveData.projectId;
        const url = isNewAlbum
            ? `${API_URL}/albums`
            : `${API_URL}/albums/${albumSaveData.projectId}`;
        const method = isNewAlbum ? 'POST' : 'PUT';
    

        const res = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: JSON.stringify(payload),
        });

        const resText = await res.text();
        let resJson: Record<string, any>;
        try {
            resJson = JSON.parse(resText);
        } catch (parseErr) {
            throw new Error(`Server returned non-JSON response: ${resText}`);
        }

        if (!res.ok) {
            const errorMsg = resJson.error || resJson.message || 'Failed to save album';
            throw new Error(errorMsg);
        }


        //  If creating a new album, persist ID and sync refs for autosave
        if (isNewAlbum && resJson._id) {
            const updated = {
                ...albumSaveData,
                _id: resJson._id,
                projectId: resJson._id,
            };

            setAlbumData(updated);

            if (lastSavedDataRef) {
                lastSavedDataRef.current = JSON.parse(JSON.stringify(updated));
            }
        }

        return true;
    } catch (error) {
        console.error('Error saving album:', error);
        return false;
    }
}
